<template>
  <section>
    <el-col style=" float:right; width: 16%; display:inline; font-size:14px; margin-top: 10px;" >
      <div style=" float: right;padding-right: 8px;"  >
        <span :style="getStylecolor(0,4)">
        </span> 
        任务取消
      </div>
      <div style=" float: right;padding-right: 8px;">
        <span :style="getStylecolor(0,1)">
        </span> 未开始
      </div>
    </el-col>

    <!--工具条-->
    <EveryDaySchedulingToolbar :buttonList="buttonList" @callFunction="callFunction" style=" float: left; width: 82%; display:inline;"></EveryDaySchedulingToolbar>

    <!--列表-->
    <el-table
      :data="runCenterTaskList"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%; font-size:18px;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        fixed="left"
        label="操作"
        width="165">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <div v-if="!scope.row.IsCancelShift" style="display: inline-flex;"> 
              <div v-if="item.name !== '恢复任务'">
                <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
              </div>
            </div>
            <div v-if="scope.row.IsCancelShift"> 
              <div v-if="item.name === '恢复任务'|| item.name==='操作日记'">
                <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
              </div>
            </div>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="LineName" label="线路名称" width="110"></el-table-column>
      <el-table-column fixed="left" label="班次" width="90" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.ShiftName === '休息'" style="color:#90EE90;font-weight:bold;">
            休息
          </div>
          <div v-else-if="scope.row.IsCancelShift">
            已取消
          </div>
          <div v-else-if="!scope.row.IsScheduling">
            待排班
          </div>
          <div v-else>
            {{scope.row.ShiftName}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="SelfMadeNumber" label="车辆自编号" width="135" sortable></el-table-column>
      <el-table-column prop="LicensePlateNumber" label="车牌号" width="120" sortable></el-table-column>
      <el-table-column prop="DriverName" label="司机" width="100" sortable></el-table-column>
      <el-table-column
        label="上行计划发车时间"
        width="450" >
        <template slot-scope="scope" >
          <span v-for="item in scope.row.DepartureTimeData" :key="item.id" >
            <el-button style="font-size:18px; margin-bottom: 5px;" type="text" :style="getStyle(1,item.State)" size="small" v-if="(scope.row.LineMode==='上下行' && item.RunningDirection === '上行') || scope.row.LineMode==='环行'" @click="handleSchedulingTask(item,scope.row)"> {{item.DepartureTimeStr}}
              <div v-if="item.SchedulingShiftRecord.IsCharter === true"
               style="color:red;">包车</div>

              <div v-if="item.SchedulingShiftRecord.VehicleId !== scope.row.VehicleId"
               style="color:red;">{{item.SchedulingShiftRecord.LicensePlateNumber}}</div> 
              <div v-if="item.SchedulingShiftRecord.DriverId !== scope.row.AfterUpdateDriverId"
               style="color:red;">{{item.SchedulingShiftRecord.DriverName}}</div> 
              <div v-if="scope.row.ShiftName==='包车'"             
               style="color:red;">{{scope.row.StartAddr}}</div> 
              </el-button>
          </span>
        </template>
      </el-table-column> 
      <el-table-column
        label="下行计划发车时间"
        width="450">
        <template slot-scope="scope">
          <span v-for="item in scope.row.DepartureTimeData" :key="item.id">
            <el-button style="font-size:18px; margin-bottom: 5px;" type="text" :style="getStyle(1,item.State)" size="small" v-if="scope.row.LineMode==='上下行' && item.RunningDirection === '下行'" @click="handleSchedulingTask(item,scope.row)">{{item.DepartureTimeStr}}
              <div v-if="item.SchedulingShiftRecord.IsCharter === true"
               style="color:red;">包车</div>
              <div v-if="item.SchedulingShiftRecord.VehicleId !== scope.row.VehicleId"
               style="color:red;">{{item.SchedulingShiftRecord.LicensePlateNumber}}</div> 
              <div v-if="item.SchedulingShiftRecord.DriverId !== scope.row.AfterUpdateDriverId"
               style="color:red;">{{item.SchedulingShiftRecord.DriverName}}</div>    
              <div v-if="scope.row.ShiftName==='包车'"             
               style="color:red;">{{scope.row.EndAddr}}</div>          
            </el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑排班任务-->
    <el-dialog
      title="编辑排班任务"
      :visible.sync="handleSchedulingTaskFormVisible"
      v-model="handleSchedulingTaskFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="schedulingTaskForm" label-width="80px" :rules="schedulingTaskFormRules" ref="schedulingTaskForm">
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="schedulingTaskForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次" prop="ShiftName" label-width="110px">
            <el-input v-model="schedulingTaskForm.ShiftName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="取消任务" prop="CancelTask" label-width="110px">
            <el-switch v-model="schedulingTaskForm.CancelTask"></el-switch>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="发车时间" prop="DepartureTimeStr" label-width="110px">
            <el-time-picker v-model="schedulingTaskForm.DepartureTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="schedulingTaskForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
       
          <el-form-item label="司机" prop="DriverId" label-width="110px">
            <el-select style="width: 100%;" v-model="schedulingTaskForm.DriverId" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>

        
        <el-row>
          <el-form-item label="包车" prop="IsCharter" label-width="110px">
            <el-switch v-model="schedulingTaskForm.IsCharter"></el-switch>
          </el-form-item>
        </el-row>

<!--        <el-row>
          <el-form-item label="发车时间" prop="StartTimeStr" label-width="110px">
            <el-time-picker v-model="schedulingTaskForm.StartTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
       
          <el-form-item label="结束时间" prop="EndTimeStr" label-width="110px">
            <el-time-picker v-model="schedulingTaskForm.EndTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="发车地点" prop="StartAddr" label-width="110px">
            <el-input v-model="schedulingTaskForm.StartAddr" />
          </el-form-item>
       
          <el-form-item label="结束地点" prop="EndAddr" label-width="110px">
            <el-input v-model="schedulingTaskForm.EndAddr" />
          </el-form-item>
        </el-row>
-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleSchedulingTaskFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSchedulingTaskSubmit" :loading="editSchedulingTaskLoading">提交</el-button>
        <el-button type="primary"  @click="lookUpSubOperateDataLog(schedulingTaskForm.SchedulingShiftRecordId)">操作日志</el-button>
      </div>
    </el-dialog>

    <!--添加任务-->
    <el-dialog
      title="添加任务"
      :visible.sync="handleAddSchedulingTaskFormVisible"
      v-model="handleAddSchedulingTaskFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="addschedulingTaskForm" label-width="80px" :rules="schedulingTaskFormRules" ref="addschedulingTaskForm">
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="addschedulingTaskForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次" prop="ShiftName" label-width="110px">
            <el-input v-model="addschedulingTaskForm.ShiftName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="线路模式" prop="CancelTask" label-width="110px" >
            <el-select style="width: 100%;" v-model="addschedulingTaskForm.LineMode" filterable placeholder="请选择车牌号" :disabled="addschedulingTaskForm.Isdisabled">
              <el-option value="上行">上行</el-option>
              <el-option value="下行">下行</el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车时间" prop="DepartureTimeStr" label-width="110px">
            <el-time-picker v-model="addschedulingTaskForm.DepartureTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="addschedulingTaskForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="司机" prop="DriverId" label-width="110px">
            <el-select style="width: 100%;" v-model="addschedulingTaskForm.DriverId" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleAddSchedulingTaskFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSchedulingTaskSubmit" :loading="addSchedulingTaskLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-row>
          <el-form-item label="司机" prop="DriverName" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.DriverId" @change="AddDrivechange" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车日期" prop="DepartureDate" label-width="110px">
            <el-input v-model="addForm.DepartureDate" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车模板" prop="SchedulingTemplateId" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.SchedulingTemplateId" @change="handleIsopenSelect" placeholder="请选择发车模板">
              <el-option
                v-for="item in schedulingtemplateList"
                :key="item.Id"
                :value="item.Id"
                :label="item.DepartureTemplate"
                @click.native=getShiftNameList(addForm.SchedulingTemplateId)
              >
                <span style="float: left">{{ item.DepartureTemplate }}</span>
              </el-option>              
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车线路" prop="BusLinesId" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.BusLinesId" placeholder="请选择发车线路">
              <el-option
                v-for="item in busLiness"
                :key="item.Id"
                :value="item.Id"
                :label="item.LineChineseName"
              >
                <span style="float: left">{{ item.LineChineseName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次名称" prop="ShiftName" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.ShiftName" filterable placeholder="请选择班次名称">
              <el-option
                v-for="item in shiftNameList"
                :key="item"
                :value="item"
                :label="item"
              >
                <span style="float: left">{{ item }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>


     <!--新增包车界面-->
     <el-dialog
      title="新增包车"
      :visible.sync="addCharterFormVisible"
      v-model="addCharterFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addCharterForm" label-width="80px" ref="addCharterForm">
        <el-row>
          <el-form-item label="司机" prop="DriverName" label-width="110px">
            <el-select style="width: 100%;" v-model="addCharterForm.DriverId" @change="AddCharterDrivechange" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="addCharterForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车日期" prop="DepartureDate" label-width="110px">
            <el-input v-model="addCharterForm.DepartureDate" :disabled="true" />
          </el-form-item>
        </el-row>   
        <el-row>
          <el-form-item label="开始时间" prop="StartTimeStr" label-width="110px">
            <el-time-picker v-model="addCharterForm.StartTimeStr" value-format="HH:mm" format="HH:mm" :default-value="new Date(0, 0, 0, 7, 0, 0)"></el-time-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="结束时间" prop="EndTimeStr" label-width="110px">
            <el-time-picker v-model="addCharterForm.EndTimeStr" value-format="HH:mm" format="HH:mm" :default-value="new Date(0, 0, 0, 18, 0, 0)"></el-time-picker>
          </el-form-item>
        </el-row>  
        <el-row>
            <el-form-item label="起始地点" prop="StartAddr" label-width="110px">
              <el-input v-model="addCharterForm.StartAddr" />
            </el-form-item>         
        </el-row> 
        <el-row>
            <el-form-item label="结束地点" prop="EndAddr" label-width="110px">
              <el-input v-model="addCharterForm.EndAddr" />
            </el-form-item>         
        </el-row>        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addCharterFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addCharterTaskSubmit" :loading="addCharterLoading">提交</el-button>
      </div>
    </el-dialog>


    <el-dialog
      title="调班"
      :visible.sync="shiftAdjustmentFormVisible"
      v-model="shiftAdjustmentFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="shiftAdjustmentForm" label-width="80px" ref="shiftAdjustmentForm">
        <el-row>
          <el-form-item label="司机" prop="DriverName" label-width="110px">
            <el-select style="width: 100%;" v-model="shiftAdjustmentForm.DriverId" @change="AdjustmentDrivechange" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="shiftAdjustmentForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车日期" prop="DepartureDate" label-width="110px">
            <el-input v-model="shiftAdjustmentForm.DepartureDate" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车模板" prop="SchedulingTemplateId" label-width="110px">
            <el-select style="width: 100%;" v-model="shiftAdjustmentForm.SchedulingTemplateId" @change="handleIsopenSelect" placeholder="请选择发车模板">
              <el-option
                v-for="item in schedulingtemplateList"
                :key="item.Id"
                :value="item.Id"
                :label="item.DepartureTemplate"
                @click.native=getShiftNameList(shiftAdjustmentForm.SchedulingTemplateId)
              >
                <span style="float: left">{{ item.DepartureTemplate }}</span>
              </el-option>              
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车线路" prop="BusLinesId" label-width="110px">
            <el-select style="width: 100%;" v-model="shiftAdjustmentForm.BusLinesId" placeholder="请选择发车线路">
              <el-option
                v-for="item in busLiness"
                :key="item.Id"
                :value="item.Id"
                :label="item.LineChineseName"
              >
                <span style="float: left">{{ item.LineChineseName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次名称" prop="ShiftName" label-width="110px">
            <el-select style="width: 100%;" v-model="shiftAdjustmentForm.ShiftName" filterable placeholder="请选择班次名称">
              <el-option
                v-for="item in shiftNameList"
                :key="item"
                :value="item"
                :label="item"
              >
                <span style="float: left">{{ item }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="shiftAdjustmentFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editShiftAdjustmentSubmit" :loading="editShiftAdjustmentLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog
      title="操作日记"
      :visible.sync="operateDataLogFormVisible"
      v-model="operateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!--排班界面-->
    <el-dialog title="排班" :visible.sync="schedulingFormVisible" v-model="schedulingFormVisible"
      :close-on-click-modal="false">
      <el-form :model="schedulingForm" label-width="80px" :rules="schedulingFormRules" ref="schedulingForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="线路名称" prop="BusLinesId" label-width="110px">
              <el-select style="width: 100%;" v-model="schedulingForm.BusLinesId" @change="selectBusLinesIdChanged"
                placeholder="请选择线路名称">
                <el-option v-for="item in busLiness" :key="item.Id" :value="item.Id" :label="item.LineChineseName">
                  <span style="float: left">{{ item.LineChineseName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="发车模版" prop="SchedulingTemplateId" label-width="110px">
              <el-select style="width: 100%;" v-model="schedulingForm.SchedulingTemplateId"
                @change="selectSchedulingTemplateIdChanged" clearable placeholder="请选择发车模版">
                <el-option v-for="item in schedulingTemplateList" :key="item.Id" :value="item.Id"
                  :label="item.DepartureTemplate">
                  <span style="float: left">{{ item.DepartureTemplate }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="排班依据" prop="SchedulingType" label-width="110px">
            <el-radio-group v-model="schedulingForm.SchedulingType" @change="schedulingTypeChange">
              <el-radio class="radio" label="首次排班">首次排班</el-radio>
              <el-radio class="radio" label="自动延续">自动延续</el-radio>
            </el-radio-group>
            <div style="color:#FF0000">注：“首次排班” 即以 “首次排班依据” 列表内容为基准，展开排班；</div>
            <div style="color:#FF0000">“自动延续” 则以系统内历史最后的班次为基准，展开排班；</div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="本次排班时间" prop="SchedulingDateRange" label-width="110px">
            <el-date-picker v-model="schedulingForm.SchedulingDateRange" type="daterange" value-format="yyyy-MM-dd"
              format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次轮换" label-width="110px">
            <el-col :span="1">
              上
            </el-col>
            <el-col :span="7">
              <el-form-item prop="ShiftRotationDays">
                <el-input v-model="schedulingForm.ShiftRotationDays" style="width:170px;"
                  :disabled="schedulingForm.SchedulingType ==='自动延续'" />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              天移动
            </el-col>
            <el-col :span="7">
              <el-form-item prop="ShiftRotationPositions">
                <el-input v-model="schedulingForm.ShiftRotationPositions" style="width:170px;"
                  :disabled="schedulingForm.SchedulingType ==='自动延续'" />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              个位置
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="休息规则" label-width="110px">
            <el-col :span="1">
              上
            </el-col>
            <el-col :span="7">
              <el-form-item prop="RestRulesDays">
                <el-input v-model="schedulingForm.RestRulesDays" style="width:170px;"
                  :disabled="schedulingForm.SchedulingType ==='自动延续'" />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              天连休
            </el-col>
            <el-col :span="7">
              <el-form-item prop="RestRulesContinuityRestDays">
                <el-input v-model="schedulingForm.RestRulesContinuityRestDays" style="width:170px;"
                  :disabled="schedulingForm.SchedulingType ==='自动延续'" />
              </el-form-item>
            </el-col>
            <el-col :span="1">
              天
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="休息后跳班" prop="IsSkipClasses" label-width="110px">
            <el-radio-group v-model="schedulingForm.IsSkipClasses" :disabled="schedulingForm.SchedulingType ==='自动延续'">
              <el-radio class="radio" label="true">是</el-radio>
              <el-radio class="radio" label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label-width="110px">
            <el-button @click.native="schedulingFormVisible = false">取消</el-button>
            <el-button type="primary" @click="handlePreview()">预览</el-button>
            <el-button type="primary" @click.native="schedulingSubmit" :loading="schedulingLoading">生成排班</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!--预览-->
    <el-dialog title="预览" :visible.sync="previewVisible" v-model="previewVisible" :close-on-click-modal="false"
      width="60%">
      <el-table :data="previewSchedulingList" highlight-current-row style="width: 100%;">
        <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
        <el-table-column fixed="left" prop="DriverName" label="驾驶员" width="100"></el-table-column>
        <el-table-column fixed="left" prop="LineName" label="线路" width="80"></el-table-column>
        <el-table-column fixed="left" prop="SchedulingTemplateName" label="排班模版" width="120" sortable></el-table-column>
        <el-table-column v-for="(item,index) in previewDynamicTableHead" :key="index" :label="item.label"
          :property="item.property" :index="item.index">
          <template slot-scope="scope">
            <div v-if="scope.row[scope.column.property][scope.column.index].ShiftName === '休息'"
              style="color:#90EE90;font-weight:bold;">
              {{scope.row[scope.column.property][scope.column.index].ShiftName}}
            </div>
            <div v-else>
              {{scope.row[scope.column.property][scope.column.index].ShiftName}}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="previewVisible = false">关闭预览</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getEveryDaySchedulingListPage,getBusLinesListPage,getDriverListPage,addeverScheduling,getSchedulingTemplateListPage,getVehiclesListPage,cancelTask, recoverTask,getClassSubitem,editSchedulingTask,editShiftAdjustment,getLineManVehicleListPage,previewScheduling,addScheduling,getByDriverIdVehiclesData,addSchedulingTask,addCharterTask,getShiftNameListPage} from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import EveryDaySchedulingToolbar from "../../components/QueryToolbar/EveryDaySchedulingToolbar";
import OperateDataLog from "../../components/OperateDataLog";
import { currentNextDate } from '../../baseCommon.js';

export default {
  components: { EveryDaySchedulingToolbar,OperateDataLog },
  data() {
    return {
      filters: {
        busLinesId: "",
        departureDate: ""
      },
      entityName: 'Scheduling', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      runCenterTaskList: [], //运行中心任务列表
      driverList: [], //驾驶员列表
      vehicleList: [], //车辆列表
      shiftNameList: [], //班次名称列表
      busLiness: [], //线路列表
      schedulingtemplateList: [], //发车模板
      schedulingTemplateList:[],      
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addFormVisible: false, //新增界面是否显示
      addCharterFormVisible: false, //新增包车界面是否显示
      handleSchedulingTaskFormVisible: false, //处理排班任务界面是否显示
      handleAddSchedulingTaskFormVisible: false, //添加排班任务界面是否显示
      editSchedulingTaskLoading: false,
      addSchedulingTaskLoading: false,
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      shiftAdjustmentFormVisible: false, //调班界面是否显示
      editShiftAdjustmentLoading: false,
      schedulingFormVisible: false, //排班界面是否显示
      previewSchedulingList: [], //预览排班列表
      previewDynamicTableHead: [],//预览排班列表动态表头
      previewVisible: false, //预览界面是否显示
      schedulingLoading: false,
      addLoading:false,
      addCharterLoading:false,
      schedulingTaskFormRules: {
        DepartureTimeStr: [{ required: true, message: "发车时间不能为空", trigger: "blur" }],
        VehicleId: [{ required: true, message: "请选择车牌号", trigger: "blur" }],
        DriverId: [{ required: true, message: "请选择司机", trigger: "blur" }]
      },
      addschedulingTaskFormRules: {
        DepartureTimeStr: [{ required: true, message: "发车时间不能为空", trigger: "blur" }],
        VehicleId: [{ required: true, message: "请选择车牌号", trigger: "blur" }],
        DriverId: [{ required: true, message: "请选择司机", trigger: "blur" }]
      },
      //编辑排班任务
      schedulingTaskForm: {
        SchedulingId: 0,
        ShiftId: 0,
        DepartureTimeId: 0,
        SchedulingShiftRecordId: 0,
        BusLinesId: 0,
        LineName: "",
        ShiftName: "",
        VehicleId: 0,
        OldVehicleId: 0,
        DriverId: 0,
        OldDriverId: 0,
        DepartureDate: "",
        DepartureTimeStr: "",
        CancelTask: false,
        IsCharter: false,
        StartTimeStr:"",
        EndTimeStr:"",
        StartAddr:"",
        EndAddr:"",
        OldDepartureTimeStr: "",
        OldCancelTask: false,
        OldIsCharter: false,
      },
      //添加排班任务
      addschedulingTaskForm: {
        SchedulingId: 0,
        ShiftId: 0,
        DepartureTimeId: 0,
        SchedulingShiftRecordId: 0,
        BusLinesId: 0,
        LineName: "",
        ShiftName: "",
        VehicleId: 0,
        OldVehicleId: 0,
        DriverId: 0,
        OldDriverId: 0,
        DepartureDate: "",
        DepartureTimeStr: "",
        CancelTask: false,
        
        LineMode:"",
        Isdisabled:false
      },
      //调班界面数据
      shiftAdjustmentForm: {
        SchedulingId: 0,
        VehicleId: 0,
        DriverName: "",
        DepartureDate: "",
        OldBusLinesId: 0,
        BusLinesId: 0,
        DriverId: 0,
        ShiftName: "",
        OldShiftName: "",
        IsScheduling: true,
        IsCancelShift: false
      },
      //添加界面数据
      addForm: {
        SchedulingId: 0,
        VehicleId: 0,
        DriverName: "",
        DepartureDate: "",
        OldBusLinesId: 0,
        BusLinesId: 0,
        DriverId: 0,
        ShiftName: "",
        OldShiftName: "",
        IsScheduling: true,
        IsCancelShift: false
      },
      //添加包车界面数据
      addCharterForm: {
        SchedulingId: 0,
        VehicleId: 0,
        DriverName: "",
        DepartureDate: "",
        StartTimeStr: "07:00",
        EndTimeStr: "18:00",
        StartAddr: "",
        EndAddr: "",        
        IsScheduling: true,
        IsCancelShift: false
      },
      runCenterTaskDetails: [] ,//运行中心任务详细数据
      //排班界面数据
      schedulingForm: {
        Id: 0,
        SchedulingTemplateId: 0,
        CreateBy: "",
        BusLinesId: 0,
        SchedulingType: "",
        SchedulingDateRange: null,
        ShiftRotationDays: 0,
        ShiftRotationPositions: 0,
        RestRulesDays: 0,
        RestRulesContinuityRestDays: 0,
        IsSkipClasses: "true"
      },
      schedulingFormRules: {
        BusLinesId: [{ required: true, message: "请选择线路名称", trigger: "blur" }],
        SchedulingType: [{ required: true, message: "请选择排班依据", trigger: "blur" }],
        SchedulingDateRange: [{ required: true, message: "请输入本次排班时间", trigger: "blur" }],
        ShiftRotationDays: [{ required: true, message: "请输入班次轮换上多少天", trigger: "blur" }],
        ShiftRotationPositions: [{ required: true, message: "请输入班次轮换移多少个位置", trigger: "blur" }],
        RestRulesDays: [{ required: true, message: "请输入休息规则上多少天", trigger: "blur" }],
        RestRulesContinuityRestDays: [{ required: true, message: "请输入休息规则连休多少天", trigger: "blur" }]
      },
    };
  },
  methods: {    
    handleIsopenSelect() {
	      this.$forceUpdate()
	   },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        busLinesId: item.busLinesId,
        departureDate: item.departureDate
      };
      this.getRunCenterTask();
      if (item.Func !== undefined)
        this[item.Func].apply(this, item);      
    },
    operationButtonFunction(item,row){      
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getRunCenterTask();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getRunCenterTask();
    },
    selectBusLinesIdChanged(val) {
      let _this = this;
      let schedulingType = _this.schedulingForm.SchedulingType;
      let schedulingTemplateId = _this.schedulingForm.SchedulingTemplateId;
      _this.schedulingFormObjectValueSet(_this, val, schedulingType, schedulingTemplateId);
      _this.getSchedulingTemplateList(val);
    },
    selectSchedulingTemplateIdChanged(val) {
      let _this = this;
      let busLinesId = _this.schedulingForm.BusLinesId;
      let schedulingType = _this.schedulingForm.SchedulingType;
      _this.schedulingFormObjectValueSet(_this, busLinesId, schedulingType, val);
    },
    schedulingTypeChange(val){
      let _this = this;
      let busLinesId =  _this.schedulingForm.BusLinesId;
      let schedulingTemplateId = _this.schedulingForm.SchedulingTemplateId;
      _this.$refs["schedulingForm"].validateField("BusLinesId");   // 此行单独校验schedulingForm表单下的线路名称单项
      _this.schedulingFormObjectValueSet(_this, busLinesId, val, schedulingTemplateId);
    },
    schedulingFormObjectValueSet(_this, busLinesId, val, schedulingTemplateId){
      if(val === "首次排班"){
        _this.$set(_this.schedulingForm,"Id", 0);
        _this.$set(_this.schedulingForm,"ShiftRotationDays", "");
        _this.$set(_this.schedulingForm,"ShiftRotationPositions", "");
        _this.$set(_this.schedulingForm,"RestRulesDays", "");
        _this.$set(_this.schedulingForm,"RestRulesContinuityRestDays", "");
        _this.$set(_this.schedulingForm,"IsSkipClasses", "true");
      }else{
        let para = {
          busLinesId: busLinesId,
          schedulingTemplateId: schedulingTemplateId === "" ? 0 : schedulingTemplateId
        };
        getSchedulingRuleData(para).then(res => {
          let schedulingRuleData = res.data;
          _this.$set(_this.schedulingForm,"Id", schedulingRuleData.Id);
          _this.$set(_this.schedulingForm,"ShiftRotationDays", schedulingRuleData.Id === 0?"":schedulingRuleData.ShiftRotationDays);
          _this.$set(_this.schedulingForm,"ShiftRotationPositions", schedulingRuleData.Id === 0?"":schedulingRuleData.ShiftRotationPositions);
          _this.$set(_this.schedulingForm,"RestRulesDays", schedulingRuleData.Id === 0?"":schedulingRuleData.RestRulesDays);
          _this.$set(_this.schedulingForm,"RestRulesContinuityRestDays", schedulingRuleData.Id === 0?"":schedulingRuleData.RestRulesContinuityRestDays);
          _this.$set(_this.schedulingForm,"IsSkipClasses", schedulingRuleData.IsSkipClasse === 0?"false":"true");
        });
      }
    },
    // 取消任务
    handleCancelTask(){
      this.$confirm("确认取消任务吗？", "提示", {}).then(() => {
        let rowData = Object.assign({}, this.currentRow);
        let para = {
          SchedulingId: rowData.SchedulingId,
          BusLinesId: rowData.BusLinesId,
          ShiftName: rowData.ShiftName,
          VehicleId: rowData.VehicleId,
          DriverId: rowData.DriverId,
          CancelTask: true,
          DepartureDate: rowData.DepartureDate
        };
        cancelTask(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.queryRunCenterTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      }).catch(() => {
          
      });
    },

    // 恢复任务
    handleRecoverTask(){
      this.$confirm("确认恢复任务吗？", "提示", {}).then(() => {
        let rowData = Object.assign({}, this.currentRow);
        let para = {
          SchedulingId: rowData.SchedulingId,
          BusLinesId: rowData.BusLinesId,
          ShiftName: rowData.ShiftName,
          VehicleId: rowData.VehicleId,
          DriverId: rowData.DriverId,
          RecoverTask: true,
          DepartureDate: rowData.DepartureDate
        };
        recoverTask(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.queryRunCenterTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      }).catch(() => {
          
      });
    },

    queryRunCenterTask(){
      this.page = 1;
      this.getRunCenterTask();
    },
    getStyle(from,state){
      let styleContent = "padding-left:5px;padding-right:5px;padding-top:3px;padding-bottom:5px;";

      if(from === 0){
        styleContent += "float:left;";
      } else if(from === 1) {
        styleContent += "color:#606266;margin-right:5px;";
      }

      if(state === 1){
        styleContent += "background-color:#FFF8DC;";
      } else if(state === 4) {
        styleContent += "background-color:#A9A9A9;";
      }

      return styleContent;
    },
    getStylecolor(from,state){
      let styleContentcolor = "width:10px; height:10px;border-radius:50%;margin-top:5px;margin-right:5px;";

      if(from === 0){
        styleContentcolor += "float:left;";
      } else if(from === 1) {
        styleContentcolor += "color:#606266;margin-right:5px;";
      }

      if(state === 1){
        styleContentcolor += "background-color:#FFF8DC;";
      } else if(state === 4) {
        styleContentcolor += "background-color:#A9A9A9;";
      }

      return styleContentcolor;
    },
    formatTime: function(time) {
      return !time || time == ""
        ? ""
        : util.formatDate.format(new Date(time), "yyyy-MM-dd");
    },
    //显示新增界面
    handleAdd() {
      let _this = this;
      let templatePara = {
        busLinesId: _this.filters.busLinesId,
        page: 1,
        pageSize: 200
      };
      getSchedulingTemplateListPage(templatePara).then(res => {
        this.schedulingtemplateList = res.data.response.data;
      });
      this.addForm.BusLinesId = _this.filters.busLinesId;
      this.addForm.SchedulingTemplateId = null;
      this.addForm.DriverId = null;
      this.addForm.VehicleId= null;
      this.addForm.ShiftName=null;
      this.addForm.DepartureDate = _this.filters.departureDate === ""?currentNextDate(1):_this.filters.departureDate;
      this.addFormVisible = true;
    },
   
     //显示新增包车界面     	
    handleAddCharter() {
      let _this = this;      
      this.addCharterForm.BusLinesId = _this.filters.busLinesId;     
      this.addCharterForm.DriverId = null;
      this.addCharterForm.VehicleId= null;
      this.addCharterForm.DepartureDate = _this.filters.departureDate === ""?currentNextDate(1):_this.filters.departureDate;
      this.addCharterFormVisible = true;
    },
   
    //显示排班界面
    handleScheduling() {
      this.schedulingFormVisible = true;
      this.schedulingForm = {
        CreateBy: "",
        BusLinesId: this.filters.busLinesId,
        SchedulingTemplateId: this.filters.schedulingTemplateId,
        SchedulingType: "首次排班",
        IsSkipClasses: "true"
      };
      this.getSchedulingTemplateList(this.filters.busLinesId, this.filters.schedulingTemplateId);
    },

    getSchedulingTemplateList(busLinesId, schedulingTemplateId) {
      this.schedulingTemplateList = [];
      this.$set(this.schedulingForm, "SchedulingTemplateId", "");
      let para = {
        busLinesId: busLinesId
      };
      getSchedulingTemplateListPage(para).then(res => {
        this.schedulingTemplateList = res.data.response.data;
        this.$set(this.schedulingForm, "SchedulingTemplateId", schedulingTemplateId);
      });
    },

    //修改司机change
    AdjustmentDrivechange() {
      let _this = this;
      let para = {
        busLinesId: _this.shiftAdjustmentForm.BusLinesId,
        driverId: _this.shiftAdjustmentForm.DriverId,
        vehicleId: '',
        isBind: '',
        page: _this.page,
        pageSize: _this.pageSize
      }; 
      getByDriverIdVehiclesData(para).then(res => {
        if(res.data.data !== null)
        {
          if(res.data.data.length > 0)
          {
            _this.shiftAdjustmentForm.VehicleId = res.data.data[0].Id;
          }
        }  
      });
    },

    //修改司机change
    AddDrivechange() {
      let _this = this;
      let para = {
        busLinesId: _this.addForm.BusLinesId,
        driverId: _this.addForm.DriverId,
        vehicleId: '',
        isBind: '',
        page: _this.page,
        pageSize: _this.pageSize
      };    
      getByDriverIdVehiclesData(para).then(res => {
        if(res.data.data !== null)
        {
          if(res.data.data.length > 0)
          {
            _this.addForm.VehicleId = res.data.data[0].Id;
          }
        }  
      });      
    },

    //修改司机change
    AddCharterDrivechange() {
      let _this = this;
      let para = {
        busLinesId: _this.addCharterForm.BusLinesId,
        driverId: _this.addCharterForm.DriverId,
        vehicleId: '',
        isBind: '',
        page: _this.page,
        pageSize: _this.pageSize
      };    
      getByDriverIdVehiclesData(para).then(res => {
        if(res.data.data !== null)
        {
          if(res.data.data.length > 0)
          {
            _this.addCharterForm.VehicleId = res.data.data[0].Id;
          }
        }  
      });      
    },

    // 显示调班
    handleShiftAdjustment(){
      let row = this.currentRow;
      this.shiftAdjustmentForm.SchedulingId = row.SchedulingId;
      this.shiftAdjustmentForm.VehicleId = row.VehicleId;
      this.shiftAdjustmentForm.DriverId = row.DriverId;
      this.shiftAdjustmentForm.DriverName = row.DriverName;
      this.shiftAdjustmentForm.DepartureDate = this.formatTime(row.DepartureDate);
      this.shiftAdjustmentForm.BusLinesId = row.BusLinesId;
      this.shiftAdjustmentForm.OldBusLinesId = row.BusLinesId;
      this.shiftAdjustmentForm.SchedulingTemplateId = row.SchedulingTemplateId;
      this.getShiftNameList(row.SchedulingTemplateId);
      this.shiftAdjustmentForm.ShiftName = row.ShiftName;
      this.shiftAdjustmentForm.OldShiftName = row.ShiftName;
      this.shiftAdjustmentForm.IsScheduling = true;
      this.shiftAdjustmentForm.IsCancelShift = row.IsCancelShift;
      this.shiftAdjustmentFormVisible = true;

      let templatePara = {
        busLinesId: row.BusLinesId,
        page: 1,
        pageSize: 200
      };
      getSchedulingTemplateListPage(templatePara).then(res => {
        this.schedulingtemplateList = res.data.response.data;
      });
    },
    // 处理排班任务
    handleSchedulingTask(item,scheduling){
      this.schedulingTaskForm.SchedulingId = scheduling.SchedulingId;
      this.schedulingTaskForm.ShiftId = item.ShiftId;
      this.schedulingTaskForm.DepartureTimeId = item.Id;
      this.schedulingTaskForm.BusLinesId = scheduling.BusLinesId;
      this.schedulingTaskForm.LineName = scheduling.LineName;
      this.schedulingTaskForm.ShiftName = scheduling.ShiftName;
      this.schedulingTaskForm.VehicleId = scheduling.VehicleId;
      this.schedulingTaskForm.OldVehicleId = scheduling.OldVehicleId;
      this.schedulingTaskForm.DriverId = scheduling.DriverId;
      this.schedulingTaskForm.OldDriverId = scheduling.OldDriverId;
      this.schedulingTaskForm.DepartureDate = scheduling.DepartureDate;
      this.schedulingTaskForm.SchedulingShiftRecordId = item.SchedulingShiftRecord.Id;
      this.schedulingTaskForm.IsCharter = item.SchedulingShiftRecord.IsCharter;
      this.schedulingTaskForm.CancelTask = item.SchedulingShiftRecord.IsCancel;
      this.schedulingTaskForm.OldCancelTask=item.SchedulingShiftRecord.IsCancel;
      this.schedulingTaskForm.OldIsCharter=item.SchedulingShiftRecord.IsCharter;
      if(item.SchedulingShiftRecord.Id > 0){
        this.schedulingTaskForm.DepartureTimeStr = item.SchedulingShiftRecord.DepartureTimeStr;
        this.schedulingTaskForm.OldDepartureTimeStr=item.SchedulingShiftRecord.DepartureTimeStr;
        this.schedulingTaskForm.VehicleId = item.SchedulingShiftRecord.VehicleId === null?scheduling.VehicleId:item.SchedulingShiftRecord.VehicleId;
        this.schedulingTaskForm.OldVehicleId = item.SchedulingShiftRecord.VehicleId === null?scheduling.VehicleId:item.SchedulingShiftRecord.VehicleId;
        this.schedulingTaskForm.DriverId = item.SchedulingShiftRecord.DriverId;
        this.schedulingTaskForm.OldDriverId = item.SchedulingShiftRecord.DriverId;
      } else {
        this.schedulingTaskForm.DepartureTimeStr = item.DepartureTimeStr;
        this.schedulingTaskForm.OldDepartureTimeStr=item.DepartureTimeStr;
        this.schedulingTaskForm.VehicleId = scheduling.VehicleId;
        this.schedulingTaskForm.OldVehicleId = scheduling.OldVehicleId;
        this.schedulingTaskForm.DriverId = scheduling.DriverId;
        this.schedulingTaskForm.OldDriverId = scheduling.OldDriverId;
      }
      if(scheduling.IsCancelShift)
      {
        this.handleSchedulingTaskFormVisible = false;
      }else
      {
        this.handleSchedulingTaskFormVisible = true;
      }
    },
    // 添加排班任务
    handleAddSchedulingTask(item,scheduling){
      
      let row = this.currentRow;
      this.addschedulingTaskForm.SchedulingId = row.SchedulingId;
      this.addschedulingTaskForm.BusLinesId = row.BusLinesId;
      this.addschedulingTaskForm.LineName = row.LineName;
      this.addschedulingTaskForm.ShiftName = row.ShiftName;
      this.addschedulingTaskForm.VehicleId = row.VehicleId;
      this.addschedulingTaskForm.OldVehicleId = row.OldVehicleId;
      this.addschedulingTaskForm.DriverId = row.DriverId;
      this.addschedulingTaskForm.OldDriverId = row.OldDriverId;
      this.addschedulingTaskForm.DepartureDate = row.DepartureDate;
      if(row.LineMode == "环行")
      {
        this.addschedulingTaskForm.LineMode = "环行";
        this.addschedulingTaskForm.Isdisabled = true;
      }else
      {
        this.addschedulingTaskForm.LineMode = "上行";
        this.addschedulingTaskForm.Isdisabled = false;
      }
      this.handleAddSchedulingTaskFormVisible = true;
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.SchedulingId;
    },
     //查看操作日记(带参数)
    lookUpOperateDataLogParameter(entityKey) {
      this.operateDataLogFormVisible = true;
      this.entityKey = entityKey;
      this.entityName="Scheduling";
    },
    //编辑排班查看操作日记
     lookUpSubOperateDataLog(SchedulingShiftRecordId) {
      this.operateDataLogFormVisible = true;
      this.entityKey = SchedulingShiftRecordId;
      this.entityName="SchedulingShiftRecord";
    },
    //获取运行中心任务列表
    getRunCenterTask() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        departureDate: _this.filters.departureDate === ""?currentNextDate(1):_this.filters.departureDate,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getEveryDaySchedulingListPage(para).then(res => {
        _this.total = res.data.dataCount;
        _this.runCenterTaskList = res.data.data;
        _this.listLoading = false;       
      });
    },
    getBusLines(pageSizePara){
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLiness = res.data.response.data;
        this.filters.busLinesId = res.data.response.data.length > 0?res.data.response.data[0].Id:"";
        this.getRunCenterTask();
      });
    },
    getDriverList(){
      let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
      getDriverListPage(driverPara).then(res => {
        this.driverList = res.data.response.data;
      });
    },
    getVehiclesList(){
      let vehiclesPara = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: 1,
        pageSize: 200
      };
      getVehiclesListPage(vehiclesPara).then(res => {
        this.vehicleList = res.data.response.data;
      });
    },
    getShiftNameList(schedulingTemplateId,type){
      
      this.shiftNameList = undefined;
      this.addForm.ShiftName= undefined;
      this.shiftAdjustmentForm.ShiftName=undefined;
      
      let para = {
        schedulingTemplateId:schedulingTemplateId
      };
      getShiftNameListPage(para).then(res => {
        this.shiftNameList = res.data;
      });
    },    
    //新增
    addSubmit: function() {
      let _this = this;      
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }
            debugger
            addeverScheduling(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getRunCenterTask();
              } else {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          })
          .catch(() => {
          
          });
        }
      });
    },
    //新增包车
    addCharterTaskSubmit: function() {      
      let _this = this;
      this.$refs.addCharterForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addCharterLoading = true;
            let para = Object.assign({}, this.addCharterForm);

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addCharterTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addCharterLoading = false;
                return;
              }
              if (res.data.success) {
                this.addCharterLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addCharterForm"].resetFields();
                this.addCharterFormVisible = false;
                this.getRunCenterTask();
              } else {
                this.addCharterLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          })
          .catch(() => {
          
          });
        }
      });
    },
    //编辑调班
    editShiftAdjustmentSubmit: function() {
      let _this = this;
      _this.$refs.shiftAdjustmentForm.validate(valid => {
        if (valid) {
          _this.$confirm("确认提交吗？", "提示", {}).then(() => {
            // 排班线路变换
            if(_this.shiftAdjustmentForm.OldBusLinesId !== _this.shiftAdjustmentForm.BusLinesId){
              _this.$confirm("是否取消？", "提示", {
                distinguishCancelAndClose: true, //区别右上角的X（action：close）和否按钮（action：cancel）
                confirmButtonText: '是',
                cancelButtonText: '否', //相当于 取消按钮
              }).then(() => {
                _this.shiftAdjustmentForm.IsCancelShift = true;
                _this.saveEditShiftAdjustment(_this);
              }).catch(action => {
                if (action === 'cancel'){
                  _this.shiftAdjustmentForm.IsScheduling = false;
                  _this.shiftAdjustmentForm.IsCancelShift = false;
                  _this.saveEditShiftAdjustment(_this);
                }
              });
            }else{
              _this.saveEditShiftAdjustment(_this);
            }
          }).catch(() => {
          
          });
        }
      });
    },
    saveEditShiftAdjustment(_this){
      _this.editShiftAdjustmentLoading = true;
      let para = Object.assign({}, _this.shiftAdjustmentForm);
      editShiftAdjustment(para).then(res => {
        if (util.isEmt.format(res)) {
          _this.editShiftAdjustmentLoading = false;
          return;
        }

        if (res.data.success) {
          _this.editShiftAdjustmentLoading = false;
          _this.$message({
            message: res.data.msg,
            type: "success"
          });
          _this.$refs["shiftAdjustmentForm"].resetFields();
          _this.shiftAdjustmentFormVisible = false;
          _this.getRunCenterTask();
        } else {
          _this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    // 编辑排班任务
    editSchedulingTaskSubmit: function() {
      this.$refs.schedulingTaskForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editSchedulingTaskLoading = true;
            let para = Object.assign({}, this.schedulingTaskForm);

            editSchedulingTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editSchedulingTaskLoading = false;
                return;
              }

              if (res.data.success) {
                this.editSchedulingTaskLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["schedulingTaskForm"].resetFields();
                this.handleSchedulingTaskFormVisible = false;
                this.getRunCenterTask();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          }).catch(() => {
          
          });
        }
      });
    },
    // 添加排班任务
    addSchedulingTaskSubmit: function() {
      this.$refs.addschedulingTaskForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addSchedulingTaskLoading = true;
            let para = Object.assign({}, this.addschedulingTaskForm);
            addSchedulingTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addSchedulingTaskLoading = false;
                return;
              }

              if (res.data.success) {
                this.addSchedulingTaskLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addschedulingTaskForm"].resetFields();
                this.handleAddSchedulingTaskFormVisible = false;
                this.getRunCenterTask();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          }).catch(() => {
          
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    },
    //预览
    handlePreview(){
      let _this = this;
      _this.$refs.schedulingForm.validate(valid => {
        if (valid) {
          let para = Object.assign({}, _this.schedulingForm);
          para.SchedulingDateRange = para.SchedulingDateRange.toString();
          para.SchedulingTemplateId = para.SchedulingTemplateId === "" ? 0 : para.SchedulingTemplateId;

          previewScheduling(para).then(res => {
            if (res.success !== undefined && res.success === false) {
              _this.$message({
                message: res.msg,
                type: "error"
              });
            } else {
              _this.previewSchedulingList = res.data.data;
              if(_this.previewSchedulingList.length > 0){
                _this.previewDynamicTableHead = [];
                let shiftNameItems = _this.previewSchedulingList[0].ShiftNameItems;
                shiftNameItems.forEach((item, index) => {
                  _this.previewDynamicTableHead.push({ index: index, property: 'ShiftNameItems' ,label: item.DateStr});
                });
                _this.previewVisible = true;
              }else{
                _this.$message({
                  message: '无预览数据',
                  type: "info"
                });
              }
            }
          });
        }
      });
    },
    // 排班
    schedulingSubmit: function() {
      let _this = this;
      this.$refs.schedulingForm.validate(valid => {
        if (valid) {
          this.$confirm("确认生成排班吗？", "提示", {}).then(() => {
            this.schedulingLoading = true;
            let para = Object.assign({}, this.schedulingForm);
            para.SchedulingDateRange = para.SchedulingDateRange.toString();
            para.SchedulingTemplateId = para.SchedulingTemplateId === "" ? 0 : para.SchedulingTemplateId;

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addScheduling(para).then(res => {
              if (util.isEmt.format(res)) {
                this.schedulingLoading = false;
                return;
              }
              if (res.data.success) {
                this.schedulingLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });                
                this.schedulingFormVisible = false;                 
                this.getRunCenterTask();            
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLines(pageSizePara);
    this.getDriverList();
    this.getVehiclesList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>
  
</style>
